export const INITIATIVE = 'wl_owpp_nutzungsdauerLandingPage';
